import React from "react";
import classNames from "classnames";

interface AvatarProps {
  firstName: string;
  lastName: string;
  className?: string;
  onClick?: () => void;
  interactive?: boolean;
}

export const Avatar = ({ firstName, lastName, className = "", onClick, interactive = true }: AvatarProps) => {
  const initials = `${firstName[0]}${lastName[0]}`.toUpperCase();
  const classes = classNames(
    "h-10 w-10 rounded-full bg-brand-purple text-md font-bold text-white transition-opacity hover:bg-brand-purple-light focus:outline-none focus:ring-0",
    className
  );

  if (!interactive) {
    return (
      <div data-testid="avatar-component" aria-hidden className={classNames("flex items-center justify-center", classes)}>
        {initials}
      </div>
    );
  }

  return (
    <button data-testid="avatar-component" type="button" onClick={onClick} aria-label={`${firstName} ${lastName}`} className={classes}>
      {initials}
    </button>
  );
};
